'use strict';
const $ = (window.jQuery = window.$ = require('jquery'));

function positionArrows($slider) {
    var $img = $slider.find('.slick-active .image-container').first();
    if (!$img.length) return;
    var imgRect = $img[0].getBoundingClientRect();
    var sliderRect = $slider[0].getBoundingClientRect();
    var top = (imgRect.top - sliderRect.top) + (imgRect.height / 2);
    $slider.find('.slick-arrow').css('top', top + 'px');
}

var gridProductListSlider = function() {
    var $sliders = $('.grid-product-list-slider');
    if ($sliders.length === 0) return;

    $sliders.each(function() {
        var $slider = $(this);
        if ($slider.find('.slick-slide').length > 0) return;

        $slider.on('init afterChange setPosition', function() {
            positionArrows($slider);
        });

        $slider.slick({
            infinite: false,
            autoplay: false,
            speed: 400,
            slidesToScroll: 1,
            slidesToShow: 3,
            dots: true,
            arrows: true,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                        arrows: false
                    }
                }
            ]
        });

        if (typeof ResizeObserver !== 'undefined') {
            new ResizeObserver(function() {
                positionArrows($slider);
            }).observe($slider[0]);
        }
    });
};

module.exports = function() {
    gridProductListSlider();
};
